import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import { CheckCircleOutlined, CloseFilledOutlined } from "@mui-symbols-material/w300"
import type { FC, ReactElement } from "react"

import { Button } from "@/components/common/Button"

interface ProductAssociatedModalProps {
  onClose: () => void
  onAddMore: () => void
}

const ProductAddMoreDialog: FC<ProductAssociatedModalProps> = ({ onClose, onAddMore }): ReactElement => {
  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      sx={{
        "& .MuiDialogTitle-root": {
          paddingBottom: "0px",
        },
        "& .MuiDialogActions-root": {
          padding: "24px",
        },
      }}
    >
      <DialogTitle>
        <Box display='flex' justifyContent='flex-end'>
          <Button size='small' appearance='text' onClick={onClose}>
            <CloseFilledOutlined className='text-blue-gray' />
          </Button>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box textAlign='center'>
          <CheckCircleOutlined className='text-[48px] text-green-500' />
          <Typography variant='h5' color='primary' className='my-6 font-normal'>
            Product(s) successfully associated!
          </Typography>
          <Typography
            variant='h6'
            className='mt-6 px-3 text-base font-normal leading-[150%] tracking-[-0.85px] text-gray-700'
          >
            Your product(s) have been successfully added as an instruction set.
          </Typography>
          <Typography variant='h6' className='px-3 text-base font-bold leading-[150%] tracking-[-0.85px] text-gray-700'>
            Would you like to associate more product(s) now?
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display='flex' justifyContent='flex-end' width='100%' p={2}>
          <Button appearance='text' variant='primary' className='mr-2' onClick={onClose}>
            Skip & Add Later
          </Button>
          <Button onClick={onAddMore}>Associate Another Product</Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default ProductAddMoreDialog
